//const localUser = JSON.parse(localStorage.getItem('adminState'))

import { authApi, paymentApi, userApi, defaultApi } from '@/service/api'

import { SIGNUP, LOGIN, LOGOUT, REGISTER, POST_USER, POST_USER_PROFILE, REFRESHTOKEN, LOAD_USERS,
         USER_BYID, LOAD_PROFILE, UPDATE_PROFILE, VERIFY_OTP, RESEND_OTP,
        GET_USERS } from '@/store/_actiontypes'
         
import { SIGNUP_SUCCESS, SIGNUP_FAILURE, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_USER,
         SET_USERS, SET_USER_BYID, SET_PROFILE } from '@/store/_mutationtypes'

const state = {
    user: null,
    userList: null,
    userDetail: null,
    profile: null,
    userByID: null,
}

const actions = {

    [GET_USERS]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/UserList', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [SIGNUP]({ commit }, payload ) {
        return new Promise((resolve, reject) => {
            userApi.post('/register', payload )
            .then(response => {
                commit(SIGNUP_SUCCESS, response.data)
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [LOGIN]({ commit }, payload ) {
        return new Promise((resolve, reject) => {
            userApi.post('/Api/Stakeholder/Login', payload )
            .then(response => {
                let user = response.data
                commit(LOGIN_SUCCESS, user)
                resolve(response)
            })
            .catch(error => {
                commit(LOGIN_FAILURE)
                reject(error.response)
            })
        })
    },

    [REGISTER]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/register-user', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [VERIFY_OTP]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/otp-verification', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },    


    [RESEND_OTP]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/otp-resend', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    }, 

    [UPDATE_PROFILE]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/update-profile', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [POST_USER]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/add-user', payload )
            .then(response => {   
                resolve(response)
            })
            .catch(error => {
                reject(error.response.data.errors.Error)
            })
        })
    },

    [POST_USER_PROFILE]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/change-user-profile', payload )
            .then(response => {   
                resolve(response)
            })
            .catch(error => {
                reject(error.response.data.errors.Error)
            })
        })
    },

    [LOAD_PROFILE]({ commit } ) {
        return new Promise((resolve, reject) => {  
            userApi.get('/users/profile')
            .then(response => {
                let profile = response.data
                commit(SET_PROFILE, profile)            
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [USER_BYID]({ commit }, payload) {
        let userByID = payload
        commit(SET_USER_BYID, userByID)
    },

    [REFRESHTOKEN]({ commit }, { refreshtoken, token }) {
        return userApi.post('/refreshtoken', {
            token,
            refreshtoken
        })
        .then(response => {
            let user = response.data
            commit(LOGIN_SUCCESS, user)
        })
        .catch(e => {
            commit(LOGIN_FAILURE)
        })
    },

    [LOGOUT]({ commit }) {
        commit(LOGOUT_USER)
    }
}

const mutations = {

    [SIGNUP_SUCCESS](state, userDetail) {
        state.userDetail = userDetail
    },

    [SIGNUP_FAILURE](state) {
        state.userDetail = null
    },

    [LOGIN_SUCCESS](state, user) {
        state.user = user
    },

    [SET_USERS](state, userList) {
        state.userList = userList  
    },

    [SET_PROFILE](state, profile) {
        state.profile = profile
    },

    [SET_USER_BYID](state, userByID) {
        state.userByID = userByID
    },

    [LOGIN_FAILURE](state) {
        state.user = null
    },

    [LOGOUT_USER](state) {
        state.user = null
    }
}


export const user = {
    namespaced: true,
    state,
    actions,
    mutations
}